export const orderListCol = [
  {
    title: "車隊名稱",
    key: "teamName"
  },
  {
    title: "司機呼號/姓名",
    key: "driverNameAndCallNumber"
  },
  {
    title: "日期時間",
    key: "orderDate"
  },
  {
    title: "工號",
    key: "employeeJobNumber"
  },
  {
    title: "姓名",
    key: "employeeName"
  },
  {
    title: "總金額",
    key: "fee",
    slot: "fee"
  },
  {
    title: "乘客備註",
    key: "passengerNote"
  },
  {
    title: "簽單備註",
    key: "signingNote"
  },
  {
    title: "異常備註",
    slot: "abnormalNote",
    align: "center"
  },
  {
    title: "動作",
    slot: "action",
    width: 150,
    align: "center"
  }
];



// WEBPACK FOOTER //
// ./src/constants/orderListCol.js